export enum Specifications {
  DownloadSTEP = 'download-step',
  DownloadSAT = 'download-sat',
  Download3DDWG = 'download-3d-dwg',
  Download2DDWG = 'download-2d-dwg',
  DownloadPDF = 'download-pdf',
  ViewBOM = 'view-bom',
  SendBOMPLM = 'send-bom-flc',
  DownloadConfiguration = 'download-configuration',
}

export const baseSpecifications = [
  {
    id: Specifications.DownloadSTEP,
    text: 'Download STEP',
  },
  {
    id: Specifications.DownloadSAT,
    text: 'Download SAT',
  },
  {
    id: Specifications.Download3DDWG,
    text: 'Download 3D DWG',
  },
  {
    id: Specifications.Download2DDWG,
    text: 'Download 2D DWG',
  },
  {
    id: Specifications.DownloadPDF,
    text: 'Download PDF',
  },
];

export const baseSpecificationIds = baseSpecifications.map(({ id }) => id);

export const specifications = [
  ...baseSpecifications,
  {
    id: Specifications.ViewBOM,
    text: 'View BOM',
  },
  {
    id: Specifications.SendBOMPLM,
    text: 'Send BOM to PLM',
  },
  {
    id: Specifications.DownloadConfiguration,
    text: 'Download Configuration',
  },
];

export const outputFileNamesSpec = [
  {
    id: Specifications.DownloadPDF,
    activityObj: ['outputIdw'],
    files: ['result.idw'],
  },
  {
    id: Specifications.DownloadPDF,
    activityObj: ['outputPdf'],
    files: ['result.pdf'],
  },
  {
    id: Specifications.ViewBOM,
    activityObj: ['outputBomJson'],
    files: ['bomRows.json'],
  },
  {
    id: Specifications.ViewBOM,
    activityObj: ['outputBomCsv'],
    files: ['bom.csv'],
  },
  {
    id: Specifications.SendBOMPLM,
    activityObj: ['outputBomJson'],
    files: ['bomRows.json'],
  },
  {
    id: Specifications.DownloadSAT,
    activityObj: ['outputExportSat'],
    files: ['export.sat'],
  },
  {
    id: Specifications.DownloadSTEP,
    activityObj: ['outputExportStp'],
    files: ['export.stp'],
  },
  {
    id: Specifications.Download3DDWG,
    activityObj: ['outputExportDwg'],
    files: ['export.dwg'],
  },
  {
    id: Specifications.Download2DDWG,
    activityObj: ['outputExport2dDwg'],
    files: ['exports.zip'],
  },
];

export default specifications;
